import { API } from "../lib/api";
import { GOOGLE_FONTS, googleFontsUrl } from "../lib/elementStyle";

// Injects @font-face rules for user-uploaded custom fonts so they render
// in the editor canvas, the OBS output page and the operator panel.
// Also loads the shared Google Fonts: all of them in the editor/operator (so the
// picker can show them), or only the ones the elements use (pass `elements`, e.g. OBS output).
export function FontFaceStyle({ fonts = [], elements = null }) {
  const used = elements
    ? elements.map((e) => e?.estilo?.fontFamily).filter(Boolean)
    : Object.keys(GOOGLE_FONTS);
  const gUrl = googleFontsUrl(used);
  const css = fonts
    .map(
      (f) =>
        `@font-face{font-family:'${f.family}';src:url('${API}/fonts/${f.id}/file');font-display:swap;}`
    )
    .join("\n");
  return (
    <>
      {gUrl && <link rel="stylesheet" href={gUrl} data-testid="google-fonts" />}
      {css && <style data-testid="custom-fontfaces">{css}</style>}
    </>
  );
}
